import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/discrepancies`, {
        params: {
            ...params
        },
    });
};

export const Summary = (params) => {
    return APIService.get(`/v01/discrepancy-summary`, {
        params: {
            ...params
        },
    });
};

export const Put = (id, body, config = {}) => {
    return APIService.put(`/v01/discrepancies/${id}`, body, config);
};

export const Resolve = (id, body, config = {}) => {
    return APIService.put(`/v01/discrepancies/${id}/resolve`, body, config);
};

export const MarkChecked = (body, config = {}) => {
    return APIService.put(`/v01/discrepancies/check`, body, config);
};

export const DiscrepanciesByProduct = (params) => {
    return APIService.get(`/v01/discrepancies/${params.sku}`, {
        params: {
            ...params
        },
    });
};

export const DiscrepancyGroupByShop = (params) => {
    return APIService.get(`/v01/discrepancy-by-shop`, {
        params: {
            ...params
        },
    });
};

const DiscrepancyService = {
    List,
    Summary,
    Put,
    Resolve,
    MarkChecked,
    DiscrepanciesByProduct,
    DiscrepancyGroupByShop
};
export default DiscrepancyService;
